import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { HttpClient } from '@angular/common/http';
import { User } from '../User';
import { AlertService } from '../alert.service';
import { ModalDirective } from 'angular-bootstrap-md';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { OpenOtpdialogComponent } from '../open-otpdialog/open-otpdialog.component';

@Component({
  selector: 'app-edit-mobile-dialog',
  templateUrl: './edit-mobile-dialog.component.html',
  styleUrls: ['./edit-mobile-dialog.component.scss']
})
export class EditMobileDialogComponent implements OnInit {
  @ViewChild('OTPModal') OTPModal: ModalDirective;
  mobile:number;
  private user: User = new User();
  emailAdd: String = "";
  addresss: String = "";
  mobileNumber: String = "";
  public showMsg;
  mobileverifyMsg:string =""; //shows msg mobile verified or not
  custData: Observable<any>;
  private debugData: Boolean = true;  // to show and hide the data in console log
 otpErrorMsg: string = ""; // to display the error msg on otp popup
 
 
 constructor(@Inject(LOCAL_STORAGE) private storage: WebStorageService, private apiService: ApiService,
 private httpClient: HttpClient, private alertService: AlertService, 
 public mob_dialogRef: MatDialogRef<EditMobileDialogComponent>, public otp_dialogRef: MatDialogRef<OpenOtpdialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: User, public dialog: MatDialog) {

}
onNoClick(): void {
  this.mob_dialogRef.close();
}
ngOnInit() {
  this.initCustData();
 }
 
  
  initCustData() {
  if (this.apiService.checkUserLoggedIn() == true) {
  let urrr = this.apiService.cutomerDetails + this.apiService.getFromLocalData('custDD');
  this.httpClient.get(urrr)
 .subscribe(
  data => this.intilizeComponent(data),
  error => this.showError(error)
 );
 
 } else {
  console.log("User Not Logged In. Please login!")
 }
 
 }
 refresh(): void {
  window.location.reload();
}
  intilizeComponent(data) {
  this.user = data;
  console.log("hurrrr" +this.user);
  if(this.user.mobileVerified == 0)
  {
   this.mobileverifyMsg="mobile not verified";
  }
  else{
   this.mobileverifyMsg="mobile verified";
  }
   }
 
  showError(msg) {
  console.log("Error Found in server");
 }
//  openOTPDialog() {
//   const dl_dialogRef = this.dialog.open(OpenOtpdialogComponent, {
//        //data: {email: this.email}
//   });

//   dl_dialogRef.afterClosed().subscribe(result => {
//     console.log('The dialog was closed');
//     this.initCustData();
    
//   });
// }
openMobileEditDialog() {
  const mob_dialogRef = this.dialog.open(EditMobileDialogComponent, {
       data: {mobile: this.user.mobile}
  });

  mob_dialogRef.afterClosed().subscribe(result => {
    console.log('The dialog waass closed');
    this.initCustData();
    //this.OTPModal.show();
    this.mobile = result;
    console.log("updated" +this.mobile)
  });
}

 mobileNumberVerified()
{
  if (this.user.mobileVerified == 0)
  {
    console.log("please verify your number")
    //this.mobileverifyMsg="mobile not verified";
    this.sendOtpN(this.user.mobile, this.user.id);
   this.OTPModal.show();
   //console.log("ADDDD" +this.user.mobile)
   //this.openOTPDialog();
  }
  else{
    console.log("update your number")
    //this.mobileverifyMsg="mobile verified";
    //this.mobileEditModal.show();
    this.openMobileEditDialog();
  }
}

// <!-- start of OTP verify function  -->
verifyOtpN(otpToVerify) {
  let postData = { 'mobile': this.user.mobile, 'otp': otpToVerify }
  if (this.debugData) {
    console.log("very otp json data is ")
    console.log(postData);
  }
  this.httpClient.post(this.apiService.verifyOTP_URL, postData)
    .subscribe(
      (detail: any) => {
        if (this.debugData) {
          console.log("very otp function API Data ")
          console.log(detail);
        }
        if (detail.status == true) {
          if (this.debugData) {
            console.log("Success OTP Verified")
          }
          this.user = detail.obj;
          this.otpErrorMsg = "OTP Verified";
          this.refresh();
        } else {
          if (this.debugData) {
            console.log(" OTP not Verified")
          }
          this.otpErrorMsg = "Incorrect OTP";
        }
      }
    )
}
// <!-- end of OTP verify function  -->

// <!-- Start of OTP send function  -->
sendOtpN(mobileNumber, custId) {
  let postData = { 'mobile': mobileNumber, 'id': custId };
  this.httpClient.post(this.apiService.sendOtpURL, postData)
    .subscribe(
      (detail: any) => {
        if (this.debugData) {
          console.log("Send OTP Api data");
          console.log(detail);
        }
        if (detail.status == true) {
          return true;
        } else {
          return false;
        }
      }
    )
}
// <!-- end of OTP send function  -->

// <!-- start of OTP Resend function  -->
resendOtpNow() {
  if (this.apiService.checkUserLoggedIn() == true) {
    let postData = { 'mobile': this.user.mobile };
    this.httpClient.post(this.apiService.resendURL, postData)
      .subscribe(
        (detail: any) => {
          if (this.debugData) {
            console.log("resend otp function API data");
            console.log(detail);
          }
          if (detail.status == true) {
            this.otpErrorMsg = "OTP sent"
          } else {
            this.otpErrorMsg = "OTP sending fail"
          }
        },
        (err) => {
          this.otpErrorMsg = "Some error occured. Please try again."
        });
  } else {
    //this.warn("Please Login");
  }
}
// <!-- end of OTP Resend function  -->
 
 updateMobileNumber(mobileNumber) {
  if (this.apiService.checkUserLoggedIn() == true) {
  let postData = { 'mobile': mobileNumber, 'id': this.user.id, 'type': 'mobile', 'oldMobile': this.user.mobile }
  //console.log("post data is");
  //console.log(postData);
  this.httpClient.post(this.apiService.profileUpdateURL, postData)
 .subscribe(
 (detail: any) => {
 
  //this.initCustData();
  console.log(this.user);
  console.log("data is" + detail)
  if (detail.status == true) {
    //this.user = detail.obj;
  console.log("otp sent to the number");
 //this.mobile= this.user.mobile;
 //this.user.mobile=detail.obj.mobile;
 this.initCustData();
  console.log("new number" + this.user.mobile);
 } else {
  console.log("PLease retry some error occured");
 }
 },
  error => this.Error1("this email address is already exist")
 )
 } else { console.log("Please login"); }
 }
 
  Error1(msg) {
  this.alertService.warn("");
 }
 }
 



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/edit-mobile-dialog/edit-mobile-dialog.component.ts